import React from 'react';
import PropTypes from 'prop-types';
import './CurrencyCard.css';

const CurrencyCard = ({ currencyAmount, cardType, currencyLabel, format }) => {
  const renderAmount = format ? format(currencyAmount) : currencyAmount;
  return (
    <div className={`currency-card ${cardType}-card`}>
      <div className="currency-container">
        <div className="currency-type">{currencyLabel}</div>
        <div className="currency-value">{renderAmount}</div>
      </div>
    </div>
  );
};

CurrencyCard.propTypes = {
  currencyAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  cardType: PropTypes.string,
  currencyLabel: PropTypes.string.isRequired,
  format: PropTypes.func
};

export default CurrencyCard;
